// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-swatches/dist/vue-swatches.min.css
// module id = 1671
// module chunks = 2